import { mutator } from 'satcheljs';
import {
    updateUserConfigurationOnAddPolicy,
    updateUserConfigurationOnRemovePolicy,
} from '../actions/internalActions';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import RetentionPolicyTag from 'owa-service/lib/contract/RetentionPolicyTag';
import {
    ActiveRetentionPolicyRowType,
    AvailableRetentionPolicyRowType,
} from '../store/schema/RetentionPolicyRowType';
import createNewRetentionPolicyTag from '../helpers/createNewRetentionPolicyTag';

mutator(updateUserConfigurationOnAddPolicy, actionMessage => {
    updateUserConfigurationVisibilityForPolicy(actionMessage.retentionPolicyRows, true);
});

mutator(updateUserConfigurationOnRemovePolicy, actionMessage => {
    updateUserConfigurationVisibilityForPolicy(actionMessage.retentionPolicyRows, false);
});

/**
 * This method updates the user configuration's RetentionPolicyTags property with the updated isVisible param.
 * If the policy is not found, we create a new one with the policy row data
 * @param retentionPolicyRows
 * @param isVisible
 */
export const updateUserConfigurationVisibilityForPolicy = (
    retentionPolicyRows: (ActiveRetentionPolicyRowType | AvailableRetentionPolicyRowType)[],
    isVisible: boolean
): void => {
    const retentionPolicyTags = getUserConfiguration().RetentionPolicyTags;
    if (!retentionPolicyTags) {
        return;
    }
    const retentionIdMap = getRetentionIdMap(retentionPolicyTags);
    retentionPolicyRows.forEach(policyRow => {
        const tag = retentionIdMap[policyRow.RetentionId];
        if (tag) {
            tag.IsVisible = isVisible;
        } else {
            retentionPolicyTags.push(createNewRetentionPolicyTag(policyRow, isVisible));
        }
    });
};

/**
 * This helper generates a map with the key as retention id and value as the RetentionPolicyTag
 * @param retentionPolicyTags
 */
export const getRetentionIdMap = (
    retentionPolicyTags: RetentionPolicyTag[]
): { [key: string]: RetentionPolicyTag } => {
    return retentionPolicyTags.reduce(
        (acc, tag) => {
            acc[tag.RetentionId] = tag;
            return acc;
        },
        {} as { [key: string]: RetentionPolicyTag }
    );
};
